import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { send } from '../api/send';

export const Demo = defineStore('demo', {
  state: () => ({             
    hidenmenu: useStorage('demo_app_hidemenu', {}),    
    settings: useStorage('demo_app_settings', {}),            
    skills: useStorage('demo_app_skills', []),
  }),
  
  getters: {


    menu: (state) => {
      let list = [
          // active
          { id: 'home', title:'Home', link:'/'},
          { id: 'people', title:'People', link:'/people'},
          { id: 'marketplace', title:'Marketplace', link:'/marketplace', new: true},
          
          // soon
          // { id: 'events', title:'Events', hidden: true},
       ]
      //  list.forEach(item => {
      //   if (state.hidenmenu[item.id] === true) item.hidden = true          
      //  });

       return list
    },

    activemenu:(state) => state.menu.filter(item => item.hidden !== true),
    moremenu:(state) => state.menu.filter(item => item.hidden === true),
    
    

    providerIcon:(state) =>{
      let url = '/images/icons/providers'
      switch (state.provider) {
        case 'email':     return `${url}/email.svg`
        case 'google':    return `${url}/google.svg`
        case 'apple':     return `${url}/apple.svg`
        default:          return `${url}/tg.svg`
      }
    },

  
      
  },
  actions: {
    
    
    // login with apple
    async refresh(){
       this.refreshSkills()
    },

    // login with apple
    async refreshSkills(){
       if (this.skills.length > 1) return  
       let res = await send('dict/skills',{})
       if (res.error) return res
       this.skills = res.resp
    },
    
    async clear(){
       this.hidenmenu = undefined       
       this.settings = undefined       
       this.skills = undefined       
    },
    
    

  },
})

